export default __webpack_public_path__ + "static/media/new-logo-mdis.7adbda53.png";